import { defineMessages } from "react-intl";
export const broadcastLobbyMessages = defineMessages({
  invalidInput: {
    id: "broadcast.title.invalid",
    defaultMessage: "Please enter valid broadcast title",
  },
  streamCover: {
    id: "broadcast.lobby.stream.cover",
    defaultMessage: "Stream Cover",
  },
  notificationForFollowers: {
    id: "broadcast.lobby.title.label",
    defaultMessage: "Notification for Followers",
  },
  permissionTitle: {
    id: "broadcast.permissions",
    defaultMessage: "Permissions",
  },
  permissionDescription: {
    id: "broadcast.before-start",
    defaultMessage:
      "Before you start your broadcast, you will be asked to allow access to the following:",
  },
  permissionConfirm: {
    id: "broadcast.permissions.confirm",
    defaultMessage: "Got It",
  },
  camera: {
    id: "broadcast.option.camera",
    defaultMessage: "Camera",
  },
  microphone: {
    id: "broadcast.permission-microphone",
    defaultMessage: "Microphone",
  },
  permissionDeniedError: {
    id: "broadcast.lobby.error.permission.denied",
    defaultMessage: "Tango needs access {br} to your camera and microphone",
  },
  battleDuration: {
    id: "broadcast.lobby.battle.duration",
    defaultMessage: "Battle Duration",
  },
  battleDurationMin: {
    id: "broadcast.lobby.battle.duration.min",
    defaultMessage: "min",
  },
  mic: {
    id: "broadcast.lobby.mic",
    defaultMessage: "Mic",
  },
  livePartyInviteSetting: {
    id: "broadcast.lobby.live.party.invite.setting",
    defaultMessage: "Who can invite me in Party",
  },
  muted: {
    id: "broadcast.lobby.muted",
    defaultMessage: "Muted",
  },
  premiumBroadcast: {
    id: "broadcast.premium",
    defaultMessage: "Premium",
  },
  partyBroadcast: {
    id: "broadcast.party",
    defaultMessage: "Party",
  },
  livePartyBroadcast: {
    id: "broadcast.live.party",
    defaultMessage: "Live Party",
  },
  invalidBroadcastPicture: {
    id: "broadcast.lobby.invalid.picture",
    defaultMessage: "Please, set Stream Cover",
  },
  premiumEntryGift: {
    id: "broadcast.lobby.premium.entry.gift",
    defaultMessage: "Entry gift",
  },
  entryGift: {
    id: "broadcast.lobby.entry.gift",
    defaultMessage: "Select Entry Gift",
  },
  goPremium: {
    id: "broadcast.lobby.premium.go.live",
    defaultMessage: "Go Premium",
  },
  changeCover: {
    id: "broadcast.lobby.change.cover",
    defaultMessage: "Change Cover",
  },
  iStartedBroadcast: {
    id: "broadcast.lobby.i.started.broadcast",
    defaultMessage: "I started Broadcast",
  },
  giftSoundsSettingsTitle: {
    id: "broadcast.lobby.settings.bottomScreen.giftAnimationSounds",
    defaultMessage: "Gift Sounds",
  },
  mirroringSettingsTitle: {
    id: "broadcast.lobby.settings.bottomScreen.mirroring",
    defaultMessage: "Switch mirroring on",
  },
  streamSettings: {
    id: "broadcast.lobby.stream.settings",
    defaultMessage: "Stream Settings",
  },
  masksAndFiltersTitle: {
    id: "broadcast.lobby.masks.and.filters",
    defaultMessage: "Masks & Filters",
  },
  quickPicInvitesTitle: {
    id: "broadcast.lobby.quick.tips.invites.title",
    defaultMessage: "Collaborate and stream with your Friends",
  },
  quickPicInvitesDescription: {
    id: "broadcast.lobby.quick.tips.invites.description",
    defaultMessage:
      "Invite Friends to Live Party during stream{br} to boost the fun!",
  },
  quickTipsTitle: {
    id: "broadcast.lobby.quick.tips.title",
    defaultMessage: "QUICK TIP",
  },
  regularStreamTitle: {
    id: "broadcast.lobby.regular.stream",
    defaultMessage: "Regular Stream",
  },
  regularStreamTitleMobile: {
    id: "broadcast.lobby.regular.stream.mobile",
    defaultMessage: "Regular",
  },
  obsStreamTitle: {
    id: "broadcast.lobby.obs.stream",
    defaultMessage: "OBS Stream",
  },
  iosStreamTitle: {
    id: "broadcast.lobby.ios.stream",
    defaultMessage: "Stream from IOS",
  },
  iosStreamTitleMobile: {
    id: "broadcast.lobby.ios.stream.mobile",
    defaultMessage: "External",
  },
  larixAppName: {
    id: "broadcast.lobby.larix.app.name",
    defaultMessage: "Larix",
  },
  boarcastAppName: {
    id: "broadcast.lobby.boarcast.app.name",
    defaultMessage: "BoarCast",
  },
  externalBroadcast: {
    id: "broadcast.external.stream",
    defaultMessage: "External Stream",
  },
  broadcastIosInstructions: {
    id: "broadcast.follow.ios.instructions",
    defaultMessage: "Follow instructions on {br} how to restream to iOS",
  },
  broadcastIosLobbyInstructions: {
    id: "broadcast.follow.ios.lobby.instructions",
    defaultMessage:
      "How to Stream to iOS <ul><li>Press “Next” to start setting up the external stream on Tango</li><li>Select one of the providers, follow their instructions</li><li>Go live and enjoy!</li></ul>",
  },
  broadcastIosInstructionsViewAction: {
    id: "broadcast.follow.ios.instructions.view.action",
    defaultMessage: "View",
  },
  setupBoarcastStepTitle: {
    id: "ios.instruction.step.setup.boarcast.title",
    defaultMessage: "Set Up the App",
  },
  setupBoarcastStepSubtitle: {
    id: "ios.instruction.step.setup.boarcast.subtitle",
    defaultMessage:
      "Scan the QR code with iOS device — it will download the app and take you straight to stream to Tango.",
  },
  downloadLarixStepTitle: {
    id: "ios.instruction.larix.step.download.title",
    defaultMessage: "1. Set Up the App",
  },
  downloadLarixStepSubtitle: {
    id: "ios.instruction.larix.step.download.subtitle",
    defaultMessage:
      "Download the app from the App Store, then scan the QR code to enter the Larix stream lobby already set for Tango.",
  },
  goLiveInLarixStepTitle: {
    id: "ios.instruction.larix.step.go.live.title",
    defaultMessage: "2. Go Live in App",
  },
  goLiveInLarixStepSubtitle: {
    id: "ios.instruction.larix.step.go.live.subtitle",
    defaultMessage: "Go live in the Larix app to start stream",
  },
  comingSoonTitle: {
    id: "ios.coming.soon.title",
    defaultMessage: "Coming soon...",
  },
  preferredExternalStreamingApp: {
    id: "ios.preferred.external.streaming.app",
    defaultMessage: "Preferred External Streaming App",
  },
  preferredExternalStreamingAppDescription: {
    id: "ios.preferred.external.streaming.app.description",
    defaultMessage:
      "This allows to skip app selection and start stream directly",
  },
  noPreferredExternalStreamingApp: {
    id: "ios.no.preferred.external.streaming.app",
    defaultMessage:
      "No default browser set. You'll be asked each time after broadcast ending.",
  },
  removePreferredExternalStreamingApp: {
    id: "ios.remove.preferred.external.streaming.app",
    defaultMessage: "Remove",
  },
});
